import {match} from 'ts-pattern';

import {CustomSectionId} from '../consts/customSectionsId';
import {isB2cCarAuditWorkspace} from './isB2cCarAuditWorkspace';

export function isCustomSectionVisible(sectionId: CustomSectionId) {
  return match<CustomSectionId>(sectionId)
    .with('SIMILAR_CARS', isB2cCarAuditWorkspace)
    .exhaustive();
}
